import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { StyledLabel } from 'elements/Label/Label';
import { StyleHMINewDropdown } from '../HMISection/HMISection.styled';
import { selectTemperatureSensor } from './TemperatureSensorSection.data';
import { FormInput } from 'elements/Inputs/FormInput';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

const TemperatureSensorSection = (props) => {
    const { selectedTag, changeHandler, formData, formName, isFormReadOnly, userRole } = props;
    const classes = useStyles();
    const dropdownInput = (field) => field.isDropdown ? (
        <StyleHMINewDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                marginLeft={field.marginLeft}
                width={field.width}
                labelWidth={field.labelWidth}
                readOnly={isFormReadOnly}
                inputTextAlign={field.inputTextAlign}
                paddingRightPlaceholder={field.paddingRightPlaceholder}
                marginTop={field.marginTop}
                marginBottom={field.marginBottom}
                direction={field.direction}
                marginRight={field.marginRight}
            />
        </StyleHMINewDropdown>
    )
        : (
            <FormInput
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                isRequired={field.isRequired}
                handleChange={changeHandler}
                labelWidth={field.labelWidth}
                width={field.width}
                marginRight={field.marginRight}
                padding={field.padding}
                type={field.type}
                maxLength={field.maxLength}
                textAlign={field.textAlign}
                userRole={userRole}
                height={field.height}
                marginTop={field.marginTop}
                textAlignLabel={field.textAlignLabel}
                isDisabled={field.isDisabled}
                readOnly={field.readOnly || isFormReadOnly}
                borderRight={field.borderRight}
                marginLeft={field.marginLeft}
            />
        );
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                selectTemperatureSensor(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '4px' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {
                                    field.isLabel
                                        ? (
                                            <StyledLabel
                                                id={field.key}
                                                fontWeight={field.fontWeight}
                                                textAlign={field.textAlign}
                                                labelWidth={field.labelWidth}
                                                padding={field.padding}
                                                fontSize={field.fontSize}
                                                color={field.color}
                                            >
                                                {field.label}
                                            </StyledLabel>
                                        )
                                        : dropdownInput(field)
                                    }
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Home, Forms }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TemperatureSensorSection);

TemperatureSensorSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string
};
